import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from './app/redux/Store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './features/assets/styles/js/theam';
import { BrowserRouter as Router } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import 'react-perfect-scrollbar/dist/css/styles.css';

import './index.css';
import ScrollToTop from './features/config/routes/ScrollToTop';
import ErrorBoundary from "../../centric-myaccount-app/src/features/components/customComponents/Error/ErrorBoundary.jsx"

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={Store}>
        <Router>
          <ScrollToTop />
          <HelmetProvider>
            <Helmet>
              <script src={'/js/jquery.min.js'} type="text/javascript"></script>
              <script src={'/js/bootstrap.bundle.min.js'} type="text/javascript"></script>

              <script src={'/js/jquery.easing.min.js'} type="text/javascript"></script>
            </Helmet>
          </HelmetProvider>
           {/* <ErrorBoundary> */}
          <App />
          {/* </ErrorBoundary> */}
        </Router>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
